import React from 'react';
// import fb from '../../../assets/icons/facebook.svg';
// import instagram from '../../../assets/icons/instagram.svg';
// import linkedin from '../../../assets/icons/linkedin.svg';

import { useTranslation } from 'react-i18next';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';


function Footer({ history }) {

  const { t: trans } = useTranslation();

  // const handleSocialLinks = (link) => {
  //   window.open(link, "_blank");
  // }

  return (<div className="footer-wrapper">
    <Container>
      <footer>
        <Row>
          {/* <Col lg>
            <h3>UniEconomy Marketplace</h3>
            <ListGroup variant="flush">
              <ListGroup.Item>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod </ListGroup.Item>
              <ListGroup.Item>Lorem r, sed diam nonumy eirmod etetur sadipscing elitr, sed diam nonumy eirmod </ListGroup.Item>
            </ListGroup>
          </Col> */}
          <Col lg className='footer-categories'>
            <h3>Uni Micro</h3>
            <ListGroup variant="flush">
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://unimicro.no/om-uni-micro">{trans('footer.about')}</a></ListGroup.Item>
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://www.unimicro.no/jobb-hos-oss">{trans('footer.work-with-us')}</a></ListGroup.Item>
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://unimicro.no/blogg">{trans('footer.blog')}</a></ListGroup.Item>
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://unimicro.no/kontakt">{trans('footer.contact-us')}</a></ListGroup.Item>
            </ListGroup>
          </Col>
          <Col lg className='footer-categories'>
            <h3>{trans('footer.client-area')}</h3>
            <ListGroup variant="flush">
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://help.unieconomy.no/">{trans('footer.area-web1')}</a></ListGroup.Item>
              {/* <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://support.unimicro.no/kurs?_ga=2.61434348.1183294864.1580389391-100918416.1568959711">kurs.unimicro.no</a></ListGroup.Item>
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://support.unimicro.no/plug-in-store?_ga=2.101802177.1183294864.1580389391-100918416.1568959711">{trans('footer.plug-in')}</a></ListGroup.Item>
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://unimicro.atlassian.net/servicedesk/customer/portal/3">{trans('footer.costomer-center')}</a></ListGroup.Item> */}
            </ListGroup>
          </Col>
          <Col lg className='footer-categories'>
            <h3>Partner</h3>
            <ListGroup variant="flush">
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://info.unieconomy.no/integrasjonspartner/hvorfor-bli-partner">
                {trans('footer.partner-1')}
              </a></ListGroup.Item>
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://info.unieconomy.no/hvorfor-bli-uni-byra">
                {trans('footer.partner-2')}
              </a></ListGroup.Item>
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://developer.softrig.com/">
                {trans('footer.partner-3')}
              </a></ListGroup.Item>
            </ListGroup>
          </Col>
          <Col lg className='footer-categories Media'>
            <h3>{trans('footer.social-media')}</h3>
            <section>
              {/* <div className='media' onClick={() => handleSocialLinks('https://www.instagram.com/unimicro/')}>
                <img src={linkedin} alt='linkedin' />
              </div>
              <div className='media' onClick={() => handleSocialLinks('https://www.facebook.com/unimicro/')}>
                <img src={fb} alt='facebook' />
              </div>
              <div className='media' onClick={() => handleSocialLinks('https://www.linkedin.com/company/uni-micro-as/')}>
                <img src={instagram} alt='instagram' />
              </div> */}
            <ListGroup variant="flush">
              <ListGroup.Item><a target="_blank" rel="noopener noreferrer" href="https://imageshop.no/no/unimicro#/w=203&s=&preview=1&info=2">
                Brand Guide
              </a></ListGroup.Item>
            </ListGroup>
            </section>
          </Col>
          {/* <Col lg>
            <h3>{trans('footer.contact-info')}</h3>
            <ListGroup variant="flush">
              <ListGroup.Item className="location">
                <Icon icon={LocationIcon} classes="xs contact-info-icon" />
                <section>
                  <p>Uni Micro AS</p>
                  <p>Modals 1391</p>
                  <p>5729 Modals</p>
                </section>
              </ListGroup.Item>
              <ListGroup.Item className="phone">
                <Icon icon={PhoneIcon} classes="xs contact-info-icon" />
                <a href="tel:004756599100">tel: 56 59 91 00</a>
              </ListGroup.Item>
              <ListGroup.Item className="mail">
                <Icon icon={EnvelopeIcon} classes="xs contact-info-icon" />
                <a href="mailto:salg@unimicro.no">salg@unimicro.no</a></ListGroup.Item>
            </ListGroup>
          </Col> */}
        </Row>
        {/* <Row className="copy-right">
          <p>Copyright © 2020 Unimicro.com. All Rights Reserved</p>
        </Row> */}
      </footer>
    </Container>
    <section className="bottom-links">
      <ul>
        <li><a href="https://www.unimicro.no" target="_blank" rel="noopener noreferrer">Uni Micro</a></li>
        <li><a href="https://www.softrig.com" target="_blank" rel="noopener noreferrer">SoftRig</a></li>
        <li><a href="https://info.uniEconomy.no" target="_blank" rel="noopener noreferrer">Uni Economy</a></li>
        <li><a href="https://support.unimicro.no/" target="_blank" rel="noopener noreferrer">Uni Økonomi V3</a></li>
        <li><a href="https://info.unieconomy.no/cookie-policy" target="_blank" rel="noopener noreferrer">Use of cookies</a></li>
      </ul>
    </section>
  </div >);
}

export default Footer;